import * as React from 'react';
import styled from 'styled-components';
import { Form, useFormsContext } from '@ally/forms';
import { CardSelectionCard, CardSelectionGroup, Label, } from '@ally/metronome-ui';
import { maskBy } from '../../../../../Utils';
// channelIndex is a sequential index, but its only distinct for the given targetIdentifier (sms | email)
const getDeliveryOptionId = ({ _channel, _channelIndex }) => `${_channel}-${_channelIndex}`;
const maskTarget = (target, getOptionType) => {
    const { _description: description, _channel: channel } = target;
    const type = getOptionType(channel);
    return maskBy[type](description);
};
const StyledCardSelectionGroup = styled(CardSelectionGroup) `
  ${({ theme: { media, space } }) => `
    ${media.up('md')} {
      max-width: 500px;
    }
    margin-bottom: ${space.lg}
  `}
`;
export const DeliveryMethodsOptions = ({ targets, onOptionSelectionChange, getOptionType, selectedRadioValue, }) => {
    const { setFieldValue } = useFormsContext();
    return (React.createElement(Form, { id: "send-to" },
        selectedRadioValue === 'text message' ? (React.createElement(Label, { htmlFor: "selectSendType" }, "Send to:")) : (React.createElement(Label, { htmlFor: "selectSendType" }, "Call:")),
        React.createElement(StyledCardSelectionGroup, { variant: "single-select", align: "stacked", id: "selectSendType", ariaLabelledby: "select-send-type-label", onSelection: (cardId) => {
                setFieldValue('loginType', cardId);
                onOptionSelectionChange(cardId);
            }, defaultSelection: getDeliveryOptionId(targets[0]) }, targets.map((target) => {
            const id = getDeliveryOptionId(target);
            const maskedTarget = maskTarget(target, getOptionType);
            return (React.createElement(CardSelectionCard, { cardId: id, title: maskedTarget, allytmfn: `selectedPhoneNumber-${id}` }));
        }))));
};
//# sourceMappingURL=DeliveryMethodsOptions.js.map